import request from '@/utils/request'

// 查询产品品类分页
export function fetchList(query) {
    return request({
        url: '/fix/category/product/page',
        method: 'get',
        params: query,
    })
}
// 查询产品品类不分页
export function devList(query) {
    return request({
        url: '/fix/dev/list',
        method: 'get',
        params: query,
    })
}
// 查询产品品类详细
export function getObj(id) {
    return request({
        url: '/fix/category/product/detail?id=' + id,
        method: 'get',
    })
}
// 新增产品品类
export function addObj(data) {
    return request({
        url: '/fix/category/product/add',
        method: 'post',
        data: data,
    })
}
// 修改产品品类
export function putObj(data) {
    return request({
        url: '/fix/category/product/edit',
        method: 'post',
        data: data,
    })
}
// 启用状态产品品类
export function editStatus(data) {
    return request({
        url: '/fix/category/product/status',
        method: 'post',
        data: data,
    })
}
// 删除产品品类
export function delObj(data) {
    return request({
        url: '/fix/category/product/delete',
        method: 'post',
        data: data,
    })
}
